module.exports = __webpack_public_path__ + "static/media/dominik-team-leader.2dca41d5.png";